// Display only: do not use formatted values for payment calculations or requests.
// Currency is always supplied by the owning tenant or authoritative document.
export const formatMoney = (value, currency) => {
  if (value && typeof value === 'object') {
    currency = value.currency || currency;
    value = value.amount_minor == null ? value.amount : Number(value.amount_minor) / 100;
  }
  if (value == null || value === '' || !Number.isFinite(Number(value))) return '—';
  const amount = Number(value);
  const code = String(currency || '').trim().toUpperCase();
  const formatted = Math.abs(amount).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${amount < 0 ? '-' : ''}${/^[A-Z]{3}$/.test(code) ? `${code} ` : ''}${formatted}`;
};
